import { useState, useRef, useEffect } from 'react';

import getImgUrl from '../../helper/getImgUrl';
import styles from '../dash_styles/modifycontact.module.css';
import api from '../../api/axios';

const ModifyContact = () => {
    const [pageData, setPageData] = useState({});
    const [formData, setFormData] = useState({
        title: '',
        experience: '',
        address: '',
        hours: '',
        email: '',
        subject: '',
        email_app: '',
        subject_app: '',
        main_photo: null
    });

    const mainPhoto = useRef();

    const fetchContactData = async () => {
        try {
            const res = await api.get('/contact');
            setPageData(res.data);
        } catch (error) {
            console.error('Error fetching contact page', error);
        }
    };

    useEffect(() => {
        fetchContactData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const submitData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value) submitData.append(key, value);
            });

            await api.put(
                '/contact/update',
                submitData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            await fetchContactData();
            setFormData({
                title: '',
                experience: '',
                address: '',
                hours: '',
                email: '',
                subject: '',
                email_app: '',
                subject_app: '',
                main_photo: null
            });

            mainPhoto.current.value = ''
        } catch (error) {
            console.error('Error updating contact page', error);
        }
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.pageEdit}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Contact page management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>content location</th>
                                        <th className={styles.col2}>content type</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col4}>input</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Main title</td>
                                        <td>Text</td>
                                        <td>{pageData?.title}</td>
                                        <td>
                                            <input
                                                type='text'
                                                name='title'
                                                placeholder="Enter new title"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Intro</td>
                                        <td>Text</td>
                                        <td>{pageData?.experience}</td>
                                        <td>
                                            <textarea
                                                name='experience'
                                                onChange={handleInputChange}
                                                className={styles.tableArea}
                                                placeholder="Enter new intro"
                                                value={formData.experience}
                                            ></textarea>
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Company address</td>
                                        <td>Text</td>
                                        <td>{pageData?.address}</td>
                                        <td>
                                            <input
                                                type='text'
                                                name='address'
                                                placeholder="Enter new address"
                                                value={formData.address}
                                                onChange={handleInputChange}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Business hours</td>
                                        <td>Text</td>
                                        <td>{pageData?.hours}</td>
                                        <td>
                                            <textarea
                                                name='hours'
                                                onChange={handleInputChange}
                                                className={styles.tableArea}
                                                placeholder="Enter new hours"
                                                value={formData.hours}
                                            ></textarea>
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Landing photo</td>
                                        <td>Picture</td>
                                        <td><img src={getImgUrl(pageData?.main_photo)} alt=''/></td>
                                        <td>
                                            <input
                                                type='file'
                                                name='main_photo'
                                                onChange={handleFileChange}
                                                ref={mainPhoto}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div> 
            </div>
            <div className={styles.emailContainer}>
                <div className={styles.email}>
                    <div className={styles.labelContainer2}>
                        <div className={styles.label}>
                            <p>General inquiry email</p>
                        </div>
                        <div className={styles.filterOrder}>
                            
                        </div>
                    </div>
                    <form>
                        <div className={styles.content}>
                            <div className={styles.emailResult}>
                                <p>EMAIL:</p>
                                <div className={styles.contentBox}><p>{pageData.email}</p></div>
                            </div>
                            <div className={styles.emailResult}>
                                <p>subject:</p>
                                <div className={styles.contentBox}><p>{pageData.subject}</p></div>
                            </div>
                        </div>
                        <div>
                            <div className={styles.inputBox}>
                                <p>Email</p>
                                <input 
                                    type='email'
                                    name='email'
                                    placeholder='Enter new email'
                                />
                            </div>
                            <div className={styles.inputBox}>
                                <p>Subject</p>
                                <input 
                                    type='email'
                                    name='email'
                                    placeholder='Enter new subject'
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className={styles.email}>

                </div>
            </div>
        </div>
    );
};

export default ModifyContact;